@if (mappedAttachments.length > 0) {
  @switch (designType) {
    @case (DesignTypeEnum.Row) {
      <app-shared-attachments-row-item
        [hasHeader]="hasHeader"
        [isIconFolderEnabled]="hasIconFolder"
        [lines]="lines"
        [mappedAttachments]="mappedAttachments"/>
    }
    @case (DesignTypeEnum.Box) {
      <app-shared-attachments-box-item
        [lines]="lines"
        [mappedAttachments]="mappedAttachments"
      />
    }
  }
}
